module.exports = __webpack_public_path__ + "img/podcasts_thumbnail-600x450.c9efd82b.jpg";